/**
 * This file is a wrapper around the jquery log event interface and is deprecated in favor of @zr/common/frontend/js/log_event
 */ /**
 * Tracks and posts events to both Mixpanel and Periscope.
 *
 * @deprecated use \@zr/common/frontend/js/log_event instead
 *
 * @param {String} eventName Event name.
 * @param {Object} [eventProperties] Event properties.
 * @param {Function} [callback] Function that executes after event is logged.
 */ export default function logEvent(eventName, eventProperties, callback) {
    var _window_$;
    if (typeof ((_window_$ = window.$) === null || _window_$ === void 0 ? void 0 : _window_$.log_event) === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("The log_event function is not available. jQuery may not be loaded.");
        return;
    }
    if (eventProperties === undefined && callback !== undefined) {
        window.$.log_event(eventName, callback);
    } else {
        window.$.log_event(eventName, eventProperties, callback);
    }
}
export function logPageView(abTest) {
    window.logPageView(true, abTest);
}
